import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Prismic from 'prismic-javascript';
import { PrismicConfig } from '../../../../helpers/prismicHelpers/PrismicAPI';
import { LanguagePrismicHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers';
import { prismicSliceHelper, prismicSliceContentRelationship } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';
import { sliceComponentsHelper } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers';
import Loader from '../../../common/elements/Loader';
import AskAnExpertForm from "./AskAnExpertForm";
import { siteOfOriginHelper } from '../../../../../client/helpers/genericHelpers';
class AskAnExpertPage extends Component {

    state = {
        slices: null
    }

    componentWillMount() {
        const siteOfOrigin = siteOfOriginHelper();
        if (siteOfOrigin === 'us') {
            browserHistory.push('/');
        }
    }

    async componentDidMount() {
        //prismic
        const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, { accessToken: PrismicConfig.apiAccessTokes });
        const json = await prismicConnection.query(Prismic.Predicates.at('my.flexible-layout.uid', 'ask-an-expert'), LanguagePrismicHelper());
        let { slices } = prismicSliceHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
        this.setState({ slices })
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.slices !== nextState.slices
    }

    render() {

        const { slices } = this.state;

        if (!slices) return <Loader />

        return (
            <React.Fragment>
                {sliceComponentsHelper(slices)}
                <AskAnExpertForm />
            </React.Fragment>
        );
    }
}

export default AskAnExpertPage;



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/AskAnExpertPage.js